import styled from 'styled-components';

export const RangePickerContainer = styled.div`
  display: flex;
  align-items: center;
`;
